import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-white py-12 sm:py-16" role="contentinfo">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 sm:gap-12 mb-10 sm:mb-12">
          <div className="col-span-2 md:col-span-1">
            <Link to="/" aria-label="MeVER ホームページへ">
              <img
                src="https://static.readdy.ai/image/05cd76bb9b80c0f39a77a9e694effa95/9687a9ed07026a2b79edd442f7404cde.png?format=webp&quality=85"
                alt="MeVER ロゴ"
                className="h-6 sm:h-8 w-auto mb-4 sm:mb-6 cursor-pointer"
                width="120"
                height="32"
                loading="lazy"
                decoding="async"
              />
            </Link>
            <p className="text-xs sm:text-sm font-extralight text-black/60 tracking-wide">
              クリエーターの環境を設計する
            </p>
          </div>

          <nav aria-label="製品リンク">
            <h4 className="text-xs sm:text-sm font-light text-black mb-3 sm:mb-4 tracking-[0.15em]">
              製品
            </h4>
            <ul className="space-y-2 sm:space-y-3">
              <li>
                <Link
                  to="/chair/pro"
                  className="text-xs sm:text-sm font-extralight text-black/60 hover:text-[#8E7AB5] transition-colors cursor-pointer tracking-wide"
                >
                  Chair Pro
                </Link>
              </li>
              <li>
                <Link
                  to="/chair/core"
                  className="text-xs sm:text-sm font-extralight text-black/60 hover:text-[#8E7AB5] transition-colors cursor-pointer tracking-wide"
                >
                  Chair Core
                </Link>
              </li>
              <li>
                <Link
                  to="/chair/style"
                  className="text-xs sm:text-sm font-extralight text-black/60 hover:text-[#8E7AB5] transition-colors cursor-pointer tracking-wide"
                >
                  Chair Style
                </Link>
              </li>
              <li>
                <Link
                  to="/accessories"
                  className="text-xs sm:text-sm font-extralight text-black/60 hover:text-[#8E7AB5] transition-colors cursor-pointer tracking-wide"
                >
                  アクセサリー
                </Link>
              </li>
              <li>
                <Link
                  to="/atelier-folio"
                  className="text-xs sm:text-sm font-extralight text-black/60 hover:text-[#8E7AB5] transition-colors cursor-pointer tracking-wide"
                >
                  Atelier Folio
                </Link>
              </li>
              <li>
                <Link
                  to="/tea"
                  className="text-xs sm:text-sm font-extralight text-black/60 hover:text-[#7B8C3E] transition-colors cursor-pointer tracking-wide"
                >
                  TEA サブスク
                </Link>
              </li>
            </ul>
          </nav>

          <nav aria-label="サービスリンク">
            <h4 className="text-xs sm:text-sm font-light text-black mb-3 sm:mb-4 tracking-[0.15em]">
              サービス
            </h4>
            <ul className="space-y-2 sm:space-y-3">
              <li>
                <Link
                  to="/rental"
                  className="text-xs sm:text-sm font-extralight text-black/60 hover:text-[#8E7AB5] transition-colors cursor-pointer tracking-wide"
                >
                  レンタル
                </Link>
              </li>
              <li>
                <Link
                  to="/coworking"
                  className="text-xs sm:text-sm font-extralight text-black/60 hover:text-[#8E7AB5] transition-colors cursor-pointer tracking-wide"
                >
                  コワーキング体験（新宿）
                </Link>
              </li>
              <li>
                <a
                  href="https://tihhyh.readdy.co"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-xs sm:text-sm font-extralight text-black/60 hover:text-[#8E7AB5] transition-colors cursor-pointer tracking-wide"
                >
                  法人のお客様
                  <span className="sr-only">（外部サイト）</span>
                </a>
              </li>
            </ul>
          </nav>

          <div>
            <h4 className="text-xs sm:text-sm font-light text-black mb-3 sm:mb-4 tracking-[0.15em]">
              会社情報
            </h4>
            <ul className="space-y-2 sm:space-y-3">
              <li>
                <Link
                  to="/about-company"
                  className="text-xs sm:text-sm font-extralight text-black/60 hover:text-[#8E7AB5] transition-colors cursor-pointer tracking-wide"
                >
                  運営会社
                </Link>
              </li>
              <li>
                <a
                  href="https://bitmoves.jp/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-xs sm:text-sm font-extralight text-black/60 hover:text-[#8E7AB5] transition-colors cursor-pointer tracking-wide"
                >
                  BITMOVES JAPAN
                  <span className="sr-only">（外部サイト）</span>
                </a>
              </li>
            </ul>

            <h4 className="text-xs sm:text-sm font-light text-black mb-3 sm:mb-4 tracking-[0.15em] mt-4 sm:mt-6">
              フォロー
            </h4>
            <div className="flex gap-3 sm:gap-4">
              <a
                href="#"
                className="w-9 h-9 sm:w-10 sm:h-10 flex items-center justify-center bg-black/5 hover:bg-[#8E7AB5] hover:text-white transition-colors rounded-md cursor-pointer"
                aria-label="Instagram（準備中）"
              >
                <i
                  className="ri-instagram-line text-base sm:text-lg"
                  aria-hidden="true"
                ></i>
              </a>
              <a
                href="#"
                className="w-9 h-9 sm:w-10 sm:h-10 flex items-center justify-center bg-black/5 hover:bg-[#8E7AB5] hover:text-white transition-colors rounded-md cursor-pointer"
                aria-label="X（旧Twitter）（準備中）"
              >
                <i
                  className="ri-twitter-x-line text-base sm:text-lg"
                  aria-hidden="true"
                ></i>
              </a>
            </div>
          </div>
        </div>

        <div className="pt-6 sm:pt-8 border-t border-black/10 flex flex-col sm:flex-row justify-between items-center gap-3 sm:gap-4">
          <p className="text-xs sm:text-sm font-extralight text-black/60 tracking-wide text-center sm:text-left">
            © 2026 MeVER by{' '}
            <a
              href="https://bitmoves.jp/"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-[#8E7AB5] transition-colors cursor-pointer"
            >
              BITMOVES JAPAN INC.
            </a>
          </p>
          <a
            href="https://readdy.ai/?ref=logo"
            target="_blank"
            rel="noopener noreferrer"
            className="text-xs sm:text-sm font-extralight text-black/60 hover:text-[#8E7AB5] transition-colors cursor-pointer tracking-wide"
          >
            Powered by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
}
